import styled from 'styled-components';

import MuiFormControlLabel from '@material-ui/core/FormControlLabel';

export const FormControlLabel = styled(MuiFormControlLabel)`
  padding: 0 10px;
`;
